import { render, staticRenderFns } from "./HumanResources.vue?vue&type=template&id=ce5b8672&scoped=true&"
import script from "./HumanResources.vue?vue&type=script&lang=js&"
export * from "./HumanResources.vue?vue&type=script&lang=js&"
import style0 from "./HumanResources.vue?vue&type=style&index=0&id=ce5b8672&prod&scoped=true&lang=css&"
import style1 from "./HumanResources.vue?vue&type=style&index=1&id=ce5b8672&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce5b8672",
  null
  
)

export default component.exports